<template>
	<div class="factor-progress-bar tw-flex tw-items-center">
		<div class="weighing-factor-bars tw-flex-auto">
			<span
				v-for="item in barLength"
				class="weighing-factor-bar"
				:class="{'completed': item <= completedItemsCount}"
			>
			</span>
		</div>
		<div class="completed-icon">
			<template v-if="isCompleted">
				<check-icon-filled class="tw-w-5" />
				<span class="completed-text" :class="[completePosition]">Completado</span>
			</template>
		</div>
	</div>
</template>

<script>
import { range } from 'ramda';
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';

export default {
	name: 'FactorProgressBar',
	components: { CheckIconFilled },
	props: {
		length: {
			type: Number,
			default: 0,
		},
		completedItemsCount: {
			type: Number,
			default: 0,
		},
		completePosition: {
			type: String,
			default: 'right',
		},
	},
	computed: {
		barLength() {
			return range(1, this.length + 1);
		},
		isCompleted() {
			return this.barLength.length === this.completedItemsCount;
		},
	},
};
</script>

<style lang="scss" scoped>
.factor-progress-bar {
	.weighing-factor-bars {
		height: 5px;
		display: flex;
		.weighing-factor-bar {
			background-color: var(--app-color-gray);
			height: 5px;
			flex: 1;
			margin-right: 5px;
			border-radius: 20px;
			&.completed {
				background-color: var(--app-color-primary);
			}
		}
		.weighing-factor-bar:last-child {
			margin-right: 0;
		}
	}
	.completed-icon {
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		.completed-text {
			position: absolute;
			font-size: 10px;
			color: var(--app-color-primary);
			&.right {
				left: 28px;
			}
			&.bottom {
				right: 28px;
				top: 15px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/FactorProgressBar.vue